import { LOCALE_ID, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DistributionGroupComponent } from './distribution-group/distribution-group.component';
import { DistributionAutomaticComponent } from './distribution-automatic/distribution-automatic.component';
import { DistributionDirectComponent } from './distribution-direct/distribution-direct.component';
import { DistributionRestrictComponent } from './distribution-restrict/distribution-restrict.component';
import { TabViewModule } from 'primeng/tabview';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { RadioButtonModule } from 'primeng/radiobutton';
import { DistributionTabsComponent } from './distribution-tabs/distribution-tabs.component';
import { TooltipModule } from 'primeng/tooltip';
import { InputNumberModule } from 'primeng/inputnumber';
import { TableModule } from 'primeng/table';
import { FileUploadModule } from 'primeng/fileupload';
import { FormsModule } from '@angular/forms';
import { CalendarModule } from 'primeng/calendar';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { CurrencyMaskModule } from 'ng2-currency-mask';
import { InputSwitchModule } from 'primeng/inputswitch';
import { ToolbarModule } from 'primeng/toolbar';
import { DistributionImportfileComponent } from './distribution-importfile/distribution-importfile.component';

@NgModule({
  declarations: [
    DistributionGroupComponent,
    DistributionAutomaticComponent,
    DistributionDirectComponent,
    DistributionRestrictComponent,
    DistributionTabsComponent,
    DistributionImportfileComponent,
  ],
  exports: [DistributionTabsComponent],
  imports: [
    FormsModule,
    CommonModule,
    TabViewModule,
    ButtonModule,
    InputTextModule,
    RadioButtonModule,
    InputNumberModule,
    TooltipModule,
    TableModule,
    FileUploadModule,
    CalendarModule,
    AutoCompleteModule,
    CurrencyMaskModule,
    InputSwitchModule,
    ToolbarModule,
  ],
  providers: [{ provide: LOCALE_ID, useValue: 'pt-BR' }],
})
export class ProductDistributionModule {}
